import { useNavigate } from "react-router-dom";
import { blogPosts } from "@/mocks/blog";

export default function RelatedArticles() {
  const navigate = useNavigate();
  
  // Get 3 featured or recent articles
  const featuredArticles = blogPosts
    .filter((post) => post.featured)
    .slice(0, 2);
  
  const recentArticles = blogPosts
    .filter((post) => !post.featured)
    .slice(0, 1);
  
  const articles = [...featuredArticles, ...recentArticles];

  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#16a34a]/10 text-[#16a34a] text-xs font-semibold px-3 py-1.5 rounded-full mb-3">
              <i className="ri-article-line"></i>
              Resources
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              Solar industry insights
            </h2>
            <p className="text-gray-500 mt-2">
              Tips, strategies, and market analysis for solar installers
            </p>
          </div>
          <button
            onClick={() => navigate("/blog")}
            className="text-[#16a34a] font-semibold text-sm hover:underline flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            View all articles
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        {/* Articles Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {articles.map((article) => (
            <article
              key={article.slug}
              onClick={() => navigate(`/blog/${article.slug}`)}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#16a34a]/30 hover:shadow-lg transition-all cursor-pointer"
            >
              {/* Image */}
              <div className="h-40 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              
              {/* Content */}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-[#f0fdf4] text-[#16a34a] text-xs font-semibold px-2.5 py-1 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-gray-400 text-xs">{article.readTime}</span>
                </div>
                
                <h3 className="font-bold text-gray-900 leading-snug mb-2 group-hover:text-[#16a34a] transition-colors line-clamp-2">
                  {article.title}
                </h3>
                
                <p className="text-gray-500 text-sm line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                
                {/* Author */}
                <div className="flex items-center gap-2 pt-4 border-t border-gray-100">
                  <div className={`w-7 h-7 ${article.authorColor} rounded-full flex items-center justify-center text-white text-xs font-bold`}>
                    {article.authorInitials}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium text-gray-700 truncate">
                      {article.author}
                    </p>
                    <p className="text-xs text-gray-400">{article.publishedAt}</p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Newsletter CTA */}
        <div className="mt-10 bg-white rounded-2xl p-6 md:p-8 border border-gray-100">
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900 mb-1">
                Get solar sales tips delivered to your inbox
              </h3>
              <p className="text-gray-500 text-sm">
                Weekly insights on closing more deals, managing your pipeline, and growing your solar business.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="px-4 py-3 rounded-xl border border-gray-200 focus:border-[#16a34a] focus:ring-2 focus:ring-[#16a34a]/20 outline-none transition-all text-sm w-full sm:w-64"
              />
              <button
                onClick={() => navigate("/signup")}
                className="bg-[#16a34a] text-white font-semibold px-6 py-3 rounded-xl hover:bg-[#15803d] transition-all cursor-pointer whitespace-nowrap"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}